import { useEffect, useState } from 'react';

const getScrollbarWidth = (): number =>
  window.innerWidth - document.documentElement.clientWidth;

interface Dimensions {
  screenWidth: number;
  screenHeight: number;
  scrollbarWidth: number;
}

const useScreenDimensions = (): Dimensions => {
  const [screenSize, setScreenSize] = useState<Dimensions>({
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    scrollbarWidth: getScrollbarWidth(),
  });

  const onResize = (): void => {
    setScreenSize({
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      scrollbarWidth: getScrollbarWidth(),
    });
  };

  useEffect(() => {
    const observer = new ResizeObserver(onResize);
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return screenSize;
};

export default useScreenDimensions;
